<template>
  <div class="container-fluid page-content">
    <register-product-step2></register-product-step2>
  </div>
</template>

<script>
  import RegisterProductStep2 from '@/components/registerStep2'
  import scrollToElement from 'scroll-to-element'
  
  export default {
    name: 'ProductRegistrationStep2',
    mounted () {
      // sprawdzenie czy pierwszy krok zostal wypelniony
      let userDataEmail = this.$store.getters.getUserEmail
      if (userDataEmail == undefined) {
        this.$router.push({ name: 'ProductRegistrationStep1'})
      }
      
      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      })
    },
    components: {
      RegisterProductStep2
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>
